module.exports = __webpack_public_path__ + "resources/img/img-zenius-apm-02-jp.da73246eb591f7608112309d1ff833ea.png";